import { loadAdminUserProfile } from "@/features/admin/api/adminUserProfileRoute";
import { AdminUserProfileRoutePage } from "@/features/admin/components/AdminUserProfileRoutePage";
import type { ExtendedProfileT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/clinicians/$userId")({
    component: UserProfilePage,
    loader: async ({ context, params }) => loadAdminUserProfile(context.queryClient, params.userId),
});

function UserProfilePage() {
    const { profile } = Route.useLoaderData();
    return <AdminUserProfileRoutePage profile={profile as ExtendedProfileT} />;
}
